if (!customElements.get('shared-faq-accordion')) {
  customElements.define(
    'shared-faq-accordion',
    class SharedFaqAccordion extends HTMLElement {
      constructor() {
        super();
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.onSummaryClick = this.onSummaryClick.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;

        this.querySelectorAll('.night-shift-more-info__item, [data-accordion-item]').forEach((item) => {
          const summary = item.querySelector('.night-shift-more-info__summary, [data-accordion-summary]');
          const answer = item.querySelector('.night-shift-more-info__answer, [data-accordion-answer]');

          if (!summary || !answer) return;

          if (item.open) answer.style.height = 'auto';
          summary.addEventListener('click', this.onSummaryClick);
        });

        this.initialized = true;
      }

      disconnectedCallback() {
        this.querySelectorAll('.night-shift-more-info__summary, [data-accordion-summary]').forEach((summary) => {
          summary.removeEventListener('click', this.onSummaryClick);
        });
        this.initialized = false;
      }

      onSummaryClick(event) {
        event.preventDefault();

        const item = event.currentTarget.closest('.night-shift-more-info__item, [data-accordion-item]');
        const answer = item?.querySelector('.night-shift-more-info__answer, [data-accordion-answer]');
        if (!item || !answer || item.dataset.animating === 'true') return;

        item.dataset.animating = 'true';
        if (item.open) {
          this.collapse(item, answer);
        } else {
          this.expand(item, answer);
        }
      }

      expand(item, answer) {
        item.open = true;
        answer.style.height = '0px';

        requestAnimationFrame(() => {
          answer.style.height = `${answer.scrollHeight}px`;
          this.finishAnimation(item, answer, true);
        });
      }

      collapse(item, answer) {
        answer.style.height = `${answer.scrollHeight}px`;

        requestAnimationFrame(() => {
          answer.style.height = '0px';
          this.finishAnimation(item, answer, false);
        });
      }

      finishAnimation(item, answer, expanded) {
        const finish = () => {
          if (expanded) {
            answer.style.height = 'auto';
          } else {
            item.open = false;
            item.classList.remove('is-collapsing');
          }
          item.dataset.animating = 'false';
          answer.removeEventListener('transitionend', finish);
        };

        if (this.reducedMotion) {
          finish();
        } else {
          answer.addEventListener('transitionend', finish);
        }
      }
    }
  );
}
